import React from "react";
import { Rates } from "mlo-rate-quotes";
import StyledRates from "./styles";
import styled from "styled-components";
import useFetch from "../../../utils/useFetch"
import { useNavigate } from "react-router-dom";

export default function RateQuotes({ data }) {
  const mloID = data[0]?.loID;
  const mloEmail = data[0]?.email || "";
  const {direct} = data[0]
  const rawNumber = direct;
const formattedNumber = rawNumber.replace(/\D/g, '') // Remove all non-digits
                                 .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
  const navigate = useNavigate();

  const loIdPricing = useFetch(process.env.REACT_APP_LOWRATES_RESOURCES + "LoanOfficersPricingId.json ");

  
  if (data === null ) {
    return <div />
  } 

  if (!loIdPricing?.disabledLOIDs.includes(mloID)) {
    return  navigate("/");
  }

  return (
    <StyledRates id='rates'>
      <h2 id="loRateTitle">TODAY'S RATES</h2>
      <p id="refinanceLoTitle">Refinance Rates</p>
      {mloID ? (
        <div id="lo-rate-component">
        <Rates
          leadSource="SELF"
          loID={mloID}
          loanOfficerEmail={mloEmail}
          showCustomizeLOApplyNowUrl
        />
</div>
       ) : null} 
         <h2 id="phoneLotext"><a href={`tel:${direct.replace(/[()\s-]/g, '')}`}>{formattedNumber}</a></h2>
    </StyledRates>
  );
}